import { ReactNode } from 'react';
import './global-score-layout.css';

interface GlobalScoreLayoutProps {
  totalScore: number | string;
  children: ReactNode;
}

export const GlobalScoreLayout: React.FC<GlobalScoreLayoutProps> = ({ totalScore, children }) => (
  <div className='global-scores'>
    <div className="total-score">Total: {totalScore} Points</div>
    <div className="scores-details-container">
      {children}
    </div>
  </div>
);
